module.exports = __webpack_public_path__ + "img/q1img.8a86638e.jpg";